import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type LayoutMigration } from '../../../services/compat/migrations/layout-migration.models';

export const dialogV2Migration: LayoutMigration = {
  mode: 'layout',
  description: 'Migrate dialog element to v2',
  run: (element: CanvasElementFrom<'dialog'>): void => {
    if (!('props' in element)) {
      // casting necessary due to the last condition making 'element: never'
      (element as CanvasElementFrom<'dialog'>).props = {} as any;
    }
  },
};
